module.exports = __webpack_public_path__ + "static/8-e88477a4c68a92132d689a5f6d609177.jpg";